
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/editar-perfil",
      function () {
        return require("private-next-pages/perfil/configuracion/editar-perfil/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/configuracion/editar-perfil"])
      });
    }
  